var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1973 32.4629C30.1973 31.629 30.8733 30.953 31.7072 30.953H64.9251C65.759 30.953 66.435 31.629 66.435 32.4629V88.1171C66.435 89.3986 64.939 90.0975 63.9561 89.2751L48.928 76.7005C48.3583 76.2238 47.5263 76.2323 46.9665 76.7207L32.6997 89.1662C31.723 90.0182 30.1973 89.3245 30.1973 88.0284V32.4629Z",
    fill: "#1C5029"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_407_15725)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 36.9926,
    r: 30.1981,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.3172,
    cy: 36.9926,
    r: 30.5756,
    stroke: "url(#paint0_linear_407_15725)",
    strokeOpacity: 0.5,
    strokeWidth: 0.754952
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_407_15725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5997 25.6132C47.8257 24.9177 48.8097 24.9177 49.0357 25.6132L51.1991 32.2716C51.3002 32.5827 51.59 32.7933 51.9171 32.7933H58.9182C59.6495 32.7933 59.9536 33.7292 59.3619 34.159L53.698 38.2742C53.4334 38.4664 53.3226 38.8072 53.4237 39.1182L55.5872 45.7766C55.8131 46.4722 55.0171 47.0506 54.4254 46.6207L48.7614 42.5056C48.4968 42.3133 48.1385 42.3133 47.8739 42.5056L42.2099 46.6207C41.6182 47.0506 40.8222 46.4722 41.0482 45.7766L43.2116 39.1182C43.3127 38.8072 43.202 38.4664 42.9374 38.2742L37.2734 34.159C36.6817 33.7292 36.9858 32.7933 37.7171 32.7933H44.7182C45.0453 32.7933 45.3351 32.5827 45.4362 32.2716L47.5997 25.6132Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_407_15725",
    x: 2.26423,
    y: -9.0595,
    width: 92.1043,
    height: 92.1042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.54952
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_407_15725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_407_15725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_407_15725",
    x: 33.9411,
    y: 25.0916,
    width: 28.7525,
    height: 27.7164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.01981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5099
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_407_15725"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_407_15725",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_15725",
    x1: 18.1191,
    y1: 23.2663,
    x2: 71.5979,
    y2: 108.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMision);
export default __webpack_public_path__ + "static/media/mision.a39c9ac475fb0ab37ff91e63d7b41fec.svg";
export { ForwardRef as ReactComponent };